import { render, staticRenderFns } from "./SetMaklPeribadi.vue?vue&type=template&id=1fb2bf4f&scoped=true&"
import script from "./SetMaklPeribadi.vue?vue&type=script&lang=js&"
export * from "./SetMaklPeribadi.vue?vue&type=script&lang=js&"
import style0 from "./SetMaklPeribadi.vue?vue&type=style&index=0&id=1fb2bf4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2bf4f",
  null
  
)

export default component.exports